/* ============================================================
   Custom Software Development page — entry
   ------------------------------------------------------------
   Imports only the JS components this page's markup uses, mirrors
   assets/css/pages/custom-software-development-services.css.
   ============================================================ */

import { initOfficeHoverReveal } from "../component/office-hover-reveal.js";
import { initAccordionGroups } from "../component/accordion.js";
import { initCaseStudiesCarousel } from "../component/case-studies-carousel.js";
import { initSteps } from "../component/steps.js";
import { initBlogSlider } from "../component/insights.js";
import { initTestimonials } from "../component/testimonials-carousel.js";
import { initWhyCarousel } from "../component/why-carousel.js";
import { initTechStackLabels } from "../component/tech-stack-label.js";
import { initbenifitsCarousel } from "../component/benifits-of-working.js";
import { equalHeight } from "../component/equal-height";
import { initCookieBar,initGooglePreferredSource,initDmcabadge } from "../component/bottom-cookie-bar.js";
import initMobileMenu from "../component/mobile-menu.js";
import { initContextMenu } from "../component/disable-rightclick.js";
import { initGlowWrapper } from "../component/glow.js";

initContextMenu();
initCookieBar();
initGooglePreferredSource();
initDmcabadge();
initOfficeHoverReveal();
initAccordionGroups();
initCaseStudiesCarousel();
initSteps();
initBlogSlider();
initTestimonials();
initWhyCarousel();
initTechStackLabels();
initbenifitsCarousel();
initMobileMenu();

document.addEventListener("DOMContentLoaded", () => {
   initGlowWrapper();
});

const updateEqualHeight = () => {
   equalHeight(
      ".why-choose-section .why-card h3"
   );
   equalHeight(
      ".services-section .service-card h3"
   );
};

    updateEqualHeight();

    window.addEventListener("load", () => {
        updateEqualHeight();
    });

    window.addEventListener("resize", () => {
        updateEqualHeight();
    });